import { useCallback, useEffect, useState } from 'react';

/** The wait the code screen shows when the server gives no hint. */
export const DEFAULT_RESEND_SECONDS = 60;

/**
 * Whole seconds until another code may be requested, counted down once a
 * second from the server's hint. No clock reads: the count only ticks.
 */
export function useResendCountdown(initialSeconds: number | null): {
  seconds: number;
  restart: (seconds: number | null | undefined) => void;
} {
  const [seconds, setSeconds] = useState(() => initialSeconds ?? DEFAULT_RESEND_SECONDS);

  useEffect(() => {
    if (seconds <= 0) return;
    const tick = setTimeout(() => setSeconds((left) => Math.max(0, left - 1)), 1000);
    return () => clearTimeout(tick);
  }, [seconds]);

  const restart = useCallback((next: number | null | undefined) => {
    setSeconds(next ?? DEFAULT_RESEND_SECONDS);
  }, []);

  return { seconds, restart };
}
